export enum AbsenceMotives {
    unspecified,
    holidays,
    medical,
    APs,
    hoursCompensation,
    lowMedical,
    permission,
    training,
    judgment
  }


// WEBPACK FOOTER //
// ./src/models/absence-motives.ts